import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import { login } from "../../../../actions/authActions";
import { Box, Flex, Icon, IconButton, Spinner, Text } from "@chakra-ui/react";
import { newBorder, textPrimary, white } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
// import { AUTH_LOGIN_SUCCESS } from "../../../../constants/authConstants";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";

const RegisterCreating = ({ isCreating, setIsCreating, handleBack }) => {
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  // STATE
  const [loadingMessage, setLoadingMessage] = useState("");

  const messages = [
    t("register.progressStep1"),
    t("register.progressStep2"),
    t("register.progressStep3"),
  ];

  // HANDLERS
  // const handleLogin = () => {
  //   dispatch(login(email, password));
  // };

  // USE EFFECT
  useEffect(() => {
    let totalDelay = 0;
    const messageInterval = 3000 / messages.length;

    messages.forEach((message, index) => {
      setTimeout(() => {
        setLoadingMessage(message);

        if (index === messages.length - 1) {
          setTimeout(() => {
            setLoadingMessage(""); // Clear messages
            setIsCreating(false); // Stop loading

            // login user
          }, messageInterval);
        }
      }, totalDelay);

      totalDelay += messageInterval;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (token && !isCreating) {
  //     console.log("Auto-login process started");

  //     // ✅ Store user info in localStorage
  //     const userInfo = {
  //       token,
  //       tenantID, // Include tenant ID if available
  //       role,
  //     };

  //     // localStorage.setItem("userInfo", JSON.stringify(userInfo));

  //     // ✅ Navigate to dashboard (or another route)
  //     // navigate("/dashboard"); // Change "/dashboard" to your actual route
  //   }
  // }, [token, role, tenantID, isCreating]);

  useEffect(() => {
    if (userInfo) {
      if (userInfo.type === "Single") {
        navigate(`/${userInfo.tenants[0].slug}/dashboard`);
        // navigate("/select-tenant");
      } else if (userInfo.type === "Multiple") {
        navigate("/select-tenant");
      }
    }
  }, [userInfo, navigate, isCreating]);

  // LOG
  // console.log("RegisterCreating.js - isCreating:", isCreating);
  // console.log("RegisterCreating.js - loadingMessage:", loadingMessage);
  // console.log("RegisterCreating.js - token:", token);
  // console.log("RegisterCreating.js - tenantID:", tenantID);
  // console.log("RegisterCreating.js - role:", role);
  // console.log("userInfo", userInfo);

  return (
    <>
      <Box
        position="absolute"
        top="2rem"
        left={`calc(29% + 2rem)`}
        zIndex={1000}
      >
        <IconButton
          border={`1px solid ${newBorder}`}
          size="md"
          borderRadius="100rem"
          bg={white}
          fontSize="20px"
          icon={<Icon h="0.875rem" as={FaArrowLeft} />}
          onClick={handleBack}
        />
      </Box>

      <Box>
        {loadingMessage && (
          <Flex direction="column" justify="center" align="center">
            <Spinner size="xl" />
            <Text mt={8} color={textPrimary} fontWeight="500" size="1.125rem">
              {loadingMessage}
            </Text>
          </Flex>
        )}
      </Box>
    </>
  );
};

export default RegisterCreating;
